//Constants used by finance-time-scale and other related classes

/* eslint-disable no-magic-numbers */
export const BASE_YEAR = 1962,
	WEEKDAYS_PER_WEEK = 5,
	WEEKEND_DAYS_PER_WEEK = 2,
	DAYS_PER_WEEK = 7,
	WEEKDAYS_PER_MONTH = 22,
	WEEKS_PER_YEAR = 52,
	MONTHS_PER_QUARTER = 3,
	[SUNDAY, MONDAY, SATURDAY] = [0, 1, 6],
	SHIFT_MONDAY_TO_DAY_0 = 6,
	SHIFTED_FRIDAY = 4,
	SHIFTED_SATURDAY = 5,
	SHIFTED_SUNDAY = 6,
	SHIFT_WEEKEND_TO_WEEKDAY = 2,
	DECEMBER = 11,
	SECONDS_PER_HOUR = 3600,
	SECONDS_PER_BI_HOUR = 2 * SECONDS_PER_HOUR,
	SECONDS_PER_MINUTE = 60,
	SECONDS_PER_QUARTER_HOUR = 15*SECONDS_PER_MINUTE,
	SECONDS_PER_FIVE_MINUTES = 5*SECONDS_PER_MINUTE,
	SECONDS_PER_HALF_MINUTE = 30,
	MILLISECONDS_PER_WEEK = 6.048e8,
	YEARS_PER_DECADE = 10,
	FIRST_HOUR = 9,
	FIRST_MINUTE = 0, //so we can have sane hour scales, leave the start of the day on the 00:00 minute/second boundary
	FIRST_SECOND = 0,
	LAST_HOUR = 16, //0 based 24 hour clock
	LAST_MINUTE = 59, //so we can have sane hour scales, leave the end of the day on the :59:59 minute/second boundary
	LAST_SECOND = 59,
	FIRST_SECOND_OF_FINANCE_DAY = FIRST_HOUR*SECONDS_PER_HOUR + FIRST_MINUTE * SECONDS_PER_MINUTE + FIRST_SECOND,
	LAST_SECOND_OF_FINANCE_DAY = LAST_HOUR*SECONDS_PER_HOUR + LAST_MINUTE * SECONDS_PER_MINUTE + LAST_SECOND,
	SECONDS_PER_FINANCE_DAY = LAST_SECOND_OF_FINANCE_DAY-FIRST_SECOND_OF_FINANCE_DAY+1,
	SECONDS_PER_FINANCE_WEEK = SECONDS_PER_FINANCE_DAY * WEEKDAYS_PER_WEEK,
	SECONDS_PER_FINANCE_MONTH = SECONDS_PER_FINANCE_DAY * WEEKDAYS_PER_MONTH,
	SECONDS_PER_FINANCE_YEAR = SECONDS_PER_FINANCE_WEEK * WEEKS_PER_YEAR;

/* eslint-enable no-magic-numbers */
